module.exports = __webpack_public_path__ + "img/2025-01-09b_1.21994b16.jpg";